import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { UserPlus } from 'lucide-react';
import { useWaitlist } from '@/context/WaitlistContext';
import { formatDistanceToNow } from 'date-fns';

export const RegistrationNotifications = () => {
  const { registrations } = useWaitlist();
  const [isVisible, setIsVisible] = useState(false);
  const [currentNotification, setCurrentNotification] = useState<{
    name: string;
    company: string;
    timestamp: number;
  } | null>(null);

  useEffect(() => {
    if (registrations.length > 0) {
      const showRandomRegistration = () => {
        const randomIndex = Math.floor(Math.random() * registrations.length);
        const registration = registrations[randomIndex];
        setCurrentNotification({
          name: registration.name,
          company: registration.company,
          timestamp: registration.timestamp
        });
        setIsVisible(true);

        // Hide after 5 seconds
        setTimeout(() => {
          setIsVisible(false);
        }, 5000);
      };

      // Show initial notification
      showRandomRegistration();

      // Set up interval to show notifications periodically
      const interval = setInterval(() => {
        showRandomRegistration();
      }, Math.random() * 7000 + 8000); // Random interval between 8-15 seconds

      return () => {
        clearInterval(interval);
      };
    }
  }, [registrations]);

  if (!currentNotification) return null;

  return (
    <div className="fixed bottom-8 left-8 z-50">
      <AnimatePresence mode="wait">
        {isVisible && (
          <motion.div
            initial={{ opacity: 0, y: 50, x: -50 }}
            animate={{ opacity: 1, y: 0, x: 0 }}
            exit={{ opacity: 0, y: 50, x: -50 }}
            className="bg-black/80 backdrop-blur-lg border border-purple-500/20 rounded-lg p-4 shadow-xl"
          >
            <div className="flex items-center gap-3">
              <div className="bg-purple-600/20 p-2 rounded-full">
                <UserPlus className="w-4 h-4 text-purple-500" />
              </div>
              <div>
                <p className="text-sm text-white">
                  <span className="font-semibold text-purple-400">
                    {currentNotification.name}
                  </span>{' '}
                  from{' '}
                  <span className="font-semibold text-purple-400">
                    {currentNotification.company}
                  </span>{' '}
                  joined the waitlist
                </p>
                <p className="text-xs text-gray-400 mt-0.5">
                  {formatDistanceToNow(currentNotification.timestamp, { addSuffix: true })}
                </p>
              </div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}; 